import { FEATURE_APP_ID } from '@client-hub/shared/constants/feature-hub'
import MfeLoader from '@client-hub/shared/react/components/MfeLoader'

const Help = () => <MfeLoader port={process.env.NX_HELP_MFE_PORT!} mfeId={FEATURE_APP_ID.HELP_MFE} />

export default Help
